import React, { useState } from 'react';
import { MainLayout } from '../layouts/MainLayout';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Badge } from '../components/ui/Badge';
import { Select } from '../components/ui/Select';
import { Input } from '../components/ui/Input';
import { Modal } from '../components/ui/Modal';
import { Plus, ClipboardCheck, Users, Mail, CheckCircle2, Circle, AlertCircle, FileText, Euro, ShoppingCart, ChevronRight } from 'lucide-react';
interface AuditingProps {
  onLogout: () => void;
}
interface AuditItem {
  id: string;
  number: string;
  category: string;
  requirement: string;
  implementation: string;
  measure: string;
  comment: string;
  status: 'open' | 'compliant' | 'non_compliant' | 'not_applicable';
  selectedSolution?: string;
  cost?: number;
  filewaveConfig?: {
    mobileClients: number;
    desktopClients: number;
  };
}
interface Audit {
  id: string;
  client: string;
  employeeCount: string;
  category: 'small' | 'medium' | 'large';
  createdAt: string;
  status: 'draft' | 'in_progress' | 'completed';
  items: AuditItem[];
}
const solutions = [{
  value: 'neocube',
  label: 'Einsatz von neocube UCS',
  cost: 1200
}, {
  value: 'filewave',
  label: 'Einsatz von Filewave MDM',
  cost: 800
}, {
  value: 'firewall',
  label: 'Firewall Installation',
  cost: 2500
}, {
  value: 'backup',
  label: 'Backup-Lösung',
  cost: 600
}, {
  value: 'training',
  label: 'Mitarbeiter-Schulung',
  cost: 450
}, {
  value: 'documentation',
  label: 'Dokumentation erstellen',
  cost: 300
}, {
  value: 'policy',
  label: 'Richtlinie erstellen',
  cost: 200
}, {
  value: 'pauschale',
  label: 'Pauschal',
  cost: 0
}];
const mockAuditItems: AuditItem[] = [{
  id: 'a1-01',
  number: 'A1-01',
  category: 'Personal',
  requirement: 'Geregelte Einarbeitung neuer Mitarbeitender',
  implementation: 'Mitarbeitende müssen zu Beginn ihrer Beschäftigung in ihre neuen Aufgaben eingearbeitet werden. Die Mitarbeitenden müssen über bestehende Handlungsanweisungen und Verfahrensweisen informiert werden.',
  measure: 'Organisatorisch',
  comment: 'evtl. Organisation oder andere Software für QM/SGDP, ansonsten Abrechnung nach Aufwand zur Erstellung von Mitarbeiter OnBoardings, ggf. Templateentwicklung',
  status: 'open'
}, {
  id: 'a1-02',
  number: 'A1-02',
  category: 'Personal',
  requirement: 'Geregelte Verfahrensweise beim Weggang von Mitarbeitenden',
  implementation: 'Ausscheidende Mitarbeitende müssen alle im Rahmen ihrer Tätigkeit erhaltenen Unterlagen, Schlüssel und Geräte sowie Ausweise und Zugangsausweise zurückgeben. Zugangsdaten (bzw. Passwörter) die ausscheidenden Mitarbeitenden bekannt waren oder von diesen genutzt wurden, müssen geändert oder vernichtet werden.',
  measure: 'Organisatorisch / Account deaktivieren',
  comment: 'Deaktivierung des Accounts im z.B. AD',
  status: 'open'
}, {
  id: 'a1-03',
  number: 'A1-03',
  category: 'Personal',
  requirement: 'Festlegung von Regelungen für den Einsatz von Fremdpersonal',
  implementation: 'Externes Personal muss wie alle eigenen Mitarbeitenden dazu verpflichtet werden, geltende Gesetze, Vorschriften und interne Regelungen einzuhalten.',
  measure: 'Organisatorisch',
  comment: '',
  status: 'open'
}, {
  id: 'a1-04',
  number: 'A1-04',
  category: 'Personal',
  requirement: 'Vertraulichkeitsvereinbarungen für den Einsatz von Fremdpersonal',
  implementation: 'Mit Vertraulichkeitsvereinbarungen in Form geschlossener werden.',
  measure: 'Organisatorisch / NDA',
  comment: 'Einmalige Pauschale zur Erstellung eines NDA',
  status: 'open'
}, {
  id: 'a1-11',
  number: 'A1-11',
  category: 'Netzwerksicherheit',
  requirement: 'Absicherung der Netzübergangspunkte',
  implementation: 'Insbesondere dem Internet, muss durch eine Firewall geschützt werden. Primäres Ziel ist, keine unerlaubten Verbindungen von außen in das geschützte Netz nach außen aufgebaut werden können.',
  measure: 'Firewall Ausgehende Verbindungen einschränken / LFDR',
  comment: 'Prüfung u. Anpassung von FW-Regeln. Analyse des Datenverkehrs. Einrichtung der Firewall einmalig pauschale',
  status: 'open'
}, {
  id: 'a1-12',
  number: 'A1-12',
  category: 'Netzwerksicherheit',
  requirement: 'Dokumentation des Netzes',
  implementation: 'Das interne Netz ist inklusiver eines Netzplanes zu dokumentieren.',
  measure: 'Netzwerk Dokumentation / Hier könnte der Netzwerkplan aus dem Uniti Netzwerk Portal schon ausreichend',
  comment: 'Einmalige Pauschale zur Erstellung einer Netzwerk Dokumentation',
  status: 'open'
}, {
  id: 'a1-13',
  number: 'A1-13',
  category: 'Netzwerksicherheit',
  requirement: 'Grundlegende Authentisierung für den Netzmanagement-Zugriff',
  implementation: 'Für den Management-Zugriff auf Netzkomponenten muss eine geeignete Authentisierung verwendet werden.',
  measure: 'Passwort Safe',
  comment: 'Überprüfung aller an das Netzwerk angeschlossenen Geräte auf sichere Zugangs- und Dokumentation',
  status: 'open'
}, {
  id: 'a1-14',
  number: 'A1-14',
  category: 'Patch- und Änderungsmanagement',
  requirement: 'Installation von Updates',
  implementation: 'Updates müssen zeitnah nach ihrer Veröffentlichung installiert werden.',
  measure: 'Filewave MDM',
  comment: 'Wiederkehrende Aufgabe, hierfür sollte eine monatliche Pauschale berechnet werden',
  status: 'open'
}, {
  id: 'a1-15',
  number: 'A1-15',
  category: 'Patch- und Änderungsmanagement',
  requirement: 'Verantwortlichkeit für Updates',
  implementation: 'Es muss festgelegt werden, wer die Updates installiert. Das ausgewählte Personal muss geschult und entsprechend Hardware, eingesetzte Betriebssysteme, eingesetzte Anwendungen und Dienste, die keine Sicherheitsupdates mehr erhalten, müssen ausgemustert oder separiert werden.',
  measure: 'Filewave MDM / Wird von uns gemacht',
  comment: 'Einrichtung Filewave MDM Server lokal pauschale 8h',
  status: 'open'
}, {
  id: 'a1-16',
  number: 'A1-16',
  category: 'Patch- und Änderungsmanagement',
  requirement: 'Identifizierung ausbleibender Updates',
  implementation: 'Hardware, eingesetzte Betriebssysteme, eingesetzte Anwendungen und Dienste, die keine Sicherheitsupdates mehr erhalten, müssen identifiziert werden.',
  measure: 'Filewave MDM / Wird von uns überwacht und aktualisiert oder die Aktualisierung mit dem Kunden organisiert z.B. Sideris Server',
  comment: 'Einmaliger Aufwand zur Identifizierung der bei Dienste, wiederkehrende Aktualisierung des z.B. B: Als sollte nach Aufwand abgerechnet werden',
  status: 'open'
}];
const mockAudits: Audit[] = [{
  id: '1',
  client: 'Zahnarztpraxis Dr. Weber',
  employeeCount: '8',
  category: 'small',
  createdAt: '2024-01-15',
  status: 'in_progress',
  items: mockAuditItems.slice(0, 5)
}, {
  id: '2',
  client: 'Zahnarztpraxis Dr. Hoffmann',
  employeeCount: '15',
  category: 'medium',
  createdAt: '2024-01-10',
  status: 'draft',
  items: mockAuditItems
}];
export function Auditing({
  onLogout
}: AuditingProps) {
  const [audits, setAudits] = useState<Audit[]>(mockAudits);
  const [selectedAudit, setSelectedAudit] = useState<Audit | null>(null);
  const [showNewAuditModal, setShowNewAuditModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [newAuditData, setNewAuditData] = useState({
    client: '',
    employeeCount: '',
    category: 'small' as 'small' | 'medium' | 'large'
  });
  const getCategoryLabel = (category: string) => {
    switch (category) {
      case 'small':
        return 'Klein (1-5 MA)';
      case 'medium':
        return 'Mittel (6-20 MA)';
      case 'large':
        return 'Groß (>20 MA)';
      default:
        return category;
    }
  };
  const getStatusBadge = (status: Audit['status']) => {
    switch (status) {
      case 'draft':
        return <Badge variant="secondary" data-id="element-327">Entwurf</Badge>;
      case 'in_progress':
        return <Badge variant="info" data-id="element-328">In Bearbeitung</Badge>;
      case 'completed':
        return <Badge variant="success" data-id="element-329">Abgeschlossen</Badge>;
    }
  };
  const handleItemStatusChange = (itemId: string, status: AuditItem['status']) => {
    if (!selectedAudit) return;
    const updatedItems = selectedAudit.items.map(item => item.id === itemId ? {
      ...item,
      status
    } : item);
    setSelectedAudit({
      ...selectedAudit,
      items: updatedItems
    });
  };
  const handleSolutionChange = (itemId: string, solutionValue: string) => {
    if (!selectedAudit) return;
    const solution = solutions.find(s => s.value === solutionValue);
    const updatedItems = selectedAudit.items.map(item => item.id === itemId ? {
      ...item,
      selectedSolution: solutionValue,
      cost: solutionValue === 'filewave' ? 0 : solutionValue === 'pauschale' ? 0 : solution?.cost,
      filewaveConfig: solutionValue === 'filewave' ? {
        mobileClients: 0,
        desktopClients: 0
      } : undefined
    } : item);
    setSelectedAudit({
      ...selectedAudit,
      items: updatedItems
    });
  };
  const handleCostChange = (itemId: string, cost: number) => {
    if (!selectedAudit) return;
    const updatedItems = selectedAudit.items.map(item => item.id === itemId ? {
      ...item,
      cost
    } : item);
    setSelectedAudit({
      ...selectedAudit,
      items: updatedItems
    });
  };
  const handleFilewaveConfigChange = (itemId: string, field: 'mobileClients' | 'desktopClients', value: number) => {
    if (!selectedAudit) return;
    const updatedItems = selectedAudit.items.map(item => {
      if (item.id === itemId && item.filewaveConfig) {
        const newConfig = {
          ...item.filewaveConfig,
          [field]: value
        };
        const calculatedCost = newConfig.mobileClients * 69 + newConfig.desktopClients * 135;
        return {
          ...item,
          filewaveConfig: newConfig,
          cost: calculatedCost
        };
      }
      return item;
    });
    setSelectedAudit({
      ...selectedAudit,
      items: updatedItems
    });
  };
  const toggleItemSelection = (itemId: string) => {
    setSelectedItems(prev => prev.includes(itemId) ? prev.filter(id => id !== itemId) : [...prev, itemId]);
  };
  const getTotalCost = () => {
    if (!selectedAudit) return 0;
    return selectedAudit.items.filter(item => item.cost !== undefined).reduce((sum, item) => sum + (item.cost || 0), 0);
  };
  const getSelectedItemsCost = () => {
    if (!selectedAudit) return 0;
    return selectedAudit.items.filter(item => selectedItems.includes(item.id) && item.cost !== undefined).reduce((sum, item) => sum + (item.cost || 0), 0);
  };
  const getStatusCounts = () => {
    if (!selectedAudit) return {
      compliant: 0,
      non_compliant: 0,
      not_applicable: 0,
      open: 0
    };
    return selectedAudit.items.reduce((acc, item) => {
      acc[item.status] = (acc[item.status] || 0) + 1;
      return acc;
    }, {
      compliant: 0,
      non_compliant: 0,
      not_applicable: 0,
      open: 0
    } as Record<string, number>);
  };
  const getCompliancePercentage = () => {
    if (!selectedAudit) return 0;
    const counts = getStatusCounts();
    const total = selectedAudit.items.length;
    const evaluated = total - counts.open;
    if (evaluated === 0) return 0;
    return Math.round(counts.compliant / evaluated * 100);
  };
  const handleCreateAudit = () => {
    const newAudit: Audit = {
      id: String(audits.length + 1),
      client: newAuditData.client,
      employeeCount: newAuditData.employeeCount,
      category: newAuditData.category,
      createdAt: new Date().toISOString().split('T')[0],
      status: 'draft',
      items: mockAuditItems.map(item => ({
        ...item
      }))
    };
    setAudits([...audits, newAudit]);
    setShowNewAuditModal(false);
    setSelectedAudit(newAudit);
    setNewAuditData({
      client: '',
      employeeCount: '',
      category: 'small'
    });
  };
  if (selectedAudit) {
    return <MainLayout title="§390 SGB V Audit - Details" onLogout={onLogout} data-id="element-330">
        <div className="mb-6" data-id="element-331">
          <Button variant="ghost" onClick={() => setSelectedAudit(null)} className="mb-4" data-id="element-332">
            ← Zurück zur Übersicht
          </Button>

          <Card data-id="element-333">
            <div className="flex items-center justify-between mb-6" data-id="element-334">
              <div data-id="element-335">
                <h2 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-336">
                  {selectedAudit.client}
                </h2>
                <div className="flex items-center gap-4 text-sm text-slate-600" data-id="element-337">
                  <span className="flex items-center gap-1" data-id="element-338">
                    <Users className="h-4 w-4" data-id="element-339" />
                    {selectedAudit.employeeCount} Mitarbeiter
                  </span>
                  <span data-id="element-340">•</span>
                  <span data-id="element-341">{getCategoryLabel(selectedAudit.category)}</span>
                  <span data-id="element-342">•</span>
                  <span data-id="element-343">
                    Erstellt:{' '}
                    {new Date(selectedAudit.createdAt).toLocaleDateString('de-DE')}
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3" data-id="element-344">
                {getStatusBadge(selectedAudit.status)}
                <Button variant="outline" size="sm" leftIcon={<Mail className="h-4 w-4" data-id="element-346" />} disabled={selectedItems.length === 0} data-id="element-345">
                  {selectedItems.length} Punkte per E-Mail senden
                </Button>
              </div>
            </div>

            {/* Cost Summary */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-347">
              <div className="p-4 bg-slate-50 rounded-lg border border-slate-200" data-id="element-348">
                <div className="flex items-center gap-2 text-sm text-slate-600 mb-1" data-id="element-349">
                  <Euro className="h-4 w-4" data-id="element-350" />
                  Gesamtkosten
                </div>
                <p className="text-2xl font-bold text-slate-900" data-id="element-351">
                  € {getTotalCost().toLocaleString('de-DE')}
                </p>
              </div>
              <div className="p-4 bg-teal-50 rounded-lg border border-teal-200" data-id="element-352">
                <div className="flex items-center gap-2 text-sm text-teal-700 mb-1" data-id="element-353">
                  <CheckCircle2 className="h-4 w-4" data-id="element-354" />
                  Ausgewählte Positionen
                </div>
                <p className="text-2xl font-bold text-teal-900" data-id="element-355">
                  {selectedItems.length} Punkte
                </p>
              </div>
              <div className="p-4 bg-blue-50 rounded-lg border border-blue-200" data-id="element-356">
                <div className="flex items-center gap-2 text-sm text-blue-700 mb-1" data-id="element-357">
                  <ShoppingCart className="h-4 w-4" data-id="element-358" />
                  Kosten Auswahl
                </div>
                <p className="text-2xl font-bold text-blue-900" data-id="element-359">
                  € {getSelectedItemsCost().toLocaleString('de-DE')}
                </p>
              </div>
            </div>

            {/* Findings Statistics */}
            <Card title="Audit Findings" className="mb-6" data-id="element-360">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-361">
                {/* Status Breakdown */}
                <div data-id="element-362">
                  <h4 className="text-sm font-semibold text-slate-700 mb-4" data-id="element-363">
                    Status-Übersicht
                  </h4>
                  <div className="space-y-3" data-id="element-364">
                    <div className="flex items-center justify-between p-3 bg-emerald-50 border border-emerald-200 rounded-lg" data-id="element-365">
                      <div className="flex items-center gap-3" data-id="element-366">
                        <CheckCircle2 className="h-5 w-5 text-emerald-600" data-id="element-367" />
                        <span className="text-sm font-medium text-emerald-900" data-id="element-368">
                          Erfüllt
                        </span>
                      </div>
                      <span className="text-xl font-bold text-emerald-900" data-id="element-369">
                        {getStatusCounts().compliant}
                      </span>
                    </div>

                    <div className="flex items-center justify-between p-3 bg-red-50 border border-red-200 rounded-lg" data-id="element-370">
                      <div className="flex items-center gap-3" data-id="element-371">
                        <AlertCircle className="h-5 w-5 text-red-600" data-id="element-372" />
                        <span className="text-sm font-medium text-red-900" data-id="element-373">
                          Nicht erfüllt
                        </span>
                      </div>
                      <span className="text-xl font-bold text-red-900" data-id="element-374">
                        {getStatusCounts().non_compliant}
                      </span>
                    </div>

                    <div className="flex items-center justify-between p-3 bg-slate-50 border border-slate-200 rounded-lg" data-id="element-375">
                      <div className="flex items-center gap-3" data-id="element-376">
                        <Circle className="h-5 w-5 text-slate-600" data-id="element-377" />
                        <span className="text-sm font-medium text-slate-900" data-id="element-378">
                          Nicht zutreffend
                        </span>
                      </div>
                      <span className="text-xl font-bold text-slate-900" data-id="element-379">
                        {getStatusCounts().not_applicable}
                      </span>
                    </div>

                    <div className="flex items-center justify-between p-3 bg-amber-50 border border-amber-200 rounded-lg" data-id="element-380">
                      <div className="flex items-center gap-3" data-id="element-381">
                        <Circle className="h-5 w-5 text-amber-600" data-id="element-382" />
                        <span className="text-sm font-medium text-amber-900" data-id="element-383">
                          Offen
                        </span>
                      </div>
                      <span className="text-xl font-bold text-amber-900" data-id="element-384">
                        {getStatusCounts().open}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Compliance Score */}
                <div data-id="element-385">
                  <h4 className="text-sm font-semibold text-slate-700 mb-4" data-id="element-386">
                    Compliance-Rate
                  </h4>
                  <div className="flex items-center justify-center h-full" data-id="element-387">
                    <div className="text-center" data-id="element-388">
                      <div className="relative inline-flex items-center justify-center w-32 h-32 mb-4" data-id="element-389">
                        <svg className="w-32 h-32 transform -rotate-90" data-id="element-390">
                          <circle cx="64" cy="64" r="56" stroke="currentColor" strokeWidth="8" fill="none" className="text-slate-200" data-id="element-391" />
                          <circle cx="64" cy="64" r="56" stroke="currentColor" strokeWidth="8" fill="none" strokeDasharray={`${2 * Math.PI * 56}`} strokeDashoffset={`${2 * Math.PI * 56 * (1 - getCompliancePercentage() / 100)}`} className={`transition-all duration-500 ${getCompliancePercentage() >= 80 ? 'text-emerald-500' : getCompliancePercentage() >= 60 ? 'text-amber-500' : 'text-red-500'}`} strokeLinecap="round" data-id="element-392" />
                        </svg>
                        <div className="absolute inset-0 flex items-center justify-center" data-id="element-393">
                          <span className="text-3xl font-bold text-slate-900" data-id="element-394">
                            {getCompliancePercentage()}%
                          </span>
                        </div>
                      </div>
                      <p className="text-sm text-slate-600" data-id="element-395">
                        {getStatusCounts().compliant} von{' '}
                        {selectedAudit.items.length - getStatusCounts().open}{' '}
                        bewerteten Punkten erfüllt
                      </p>
                      {getCompliancePercentage() >= 80 && <p className="text-xs text-emerald-600 font-medium mt-2" data-id="element-396">
                          ✓ Gute Compliance-Rate
                        </p>}
                      {getCompliancePercentage() < 60 && getCompliancePercentage() > 0 && <p className="text-xs text-red-600 font-medium mt-2" data-id="element-397">
                            ⚠ Handlungsbedarf erforderlich
                          </p>}
                    </div>
                  </div>
                </div>
              </div>
            </Card>

            <div className="flex justify-end mb-4" data-id="element-398">
              <Button leftIcon={<FileText className="h-4 w-4" data-id="element-400" />} disabled={selectedItems.length === 0} data-id="element-399">
                In Angebot übernehmen
              </Button>
            </div>
          </Card>
        </div>

        {/* Audit Items */}
        <div className="space-y-4" data-id="element-401">
          {selectedAudit.items.map(item => <Card key={item.id} className="hover:shadow-md transition-shadow" data-id="element-402">
              <div className="flex items-start gap-4" data-id="element-403">
                <input type="checkbox" checked={selectedItems.includes(item.id)} onChange={() => toggleItemSelection(item.id)} className="mt-1 h-5 w-5 rounded border-slate-300 text-teal-600 focus:ring-teal-500" data-id="element-404" />

                <div className="flex-1" data-id="element-405">
                  <div className="flex items-start justify-between mb-3" data-id="element-406">
                    <div className="flex items-center gap-3" data-id="element-407">
                      <Badge variant="outline" data-id="element-408">{item.number}</Badge>
                      <h3 className="font-semibold text-slate-900" data-id="element-409">
                        {item.requirement}
                      </h3>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-410">
                      <button onClick={() => handleItemStatusChange(item.id, 'compliant')} className={`p-2 rounded-lg transition-colors ${item.status === 'compliant' ? 'bg-emerald-100' : 'hover:bg-slate-100'}`} title="Erfüllt" data-id="element-411">
                        <CheckCircle2 className={`h-5 w-5 ${item.status === 'compliant' ? 'text-emerald-600' : 'text-slate-400'}`} data-id="element-412" />
                      </button>
                      <button onClick={() => handleItemStatusChange(item.id, 'non_compliant')} className={`p-2 rounded-lg transition-colors ${item.status === 'non_compliant' ? 'bg-red-100' : 'hover:bg-slate-100'}`} title="Nicht erfüllt" data-id="element-413">
                        <AlertCircle className={`h-5 w-5 ${item.status === 'non_compliant' ? 'text-red-600' : 'text-slate-400'}`} data-id="element-414" />
                      </button>
                      <button onClick={() => handleItemStatusChange(item.id, 'not_applicable')} className={`p-2 rounded-lg transition-colors ${item.status === 'not_applicable' ? 'bg-slate-100' : 'hover:bg-slate-100'}`} title="Nicht zutreffend" data-id="element-415">
                        <Circle className={`h-5 w-5 ${item.status === 'not_applicable' ? 'text-slate-600' : 'text-slate-400'}`} data-id="element-416" />
                      </button>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-417">
                    <div data-id="element-418">
                      <p className="text-xs font-semibold text-slate-500 uppercase mb-1" data-id="element-419">
                        Kategorie
                      </p>
                      <p className="text-sm text-slate-700" data-id="element-420">{item.category}</p>
                    </div>
                    <div data-id="element-421">
                      <p className="text-xs font-semibold text-slate-500 uppercase mb-1" data-id="element-422">
                        Maßnahme
                      </p>
                      <p className="text-sm text-slate-700" data-id="element-423">{item.measure}</p>
                    </div>
                  </div>

                  <div className="mb-4" data-id="element-424">
                    <p className="text-xs font-semibold text-slate-500 uppercase mb-1" data-id="element-425">
                      Erfassung
                    </p>
                    <p className="text-sm text-slate-700" data-id="element-426">
                      {item.implementation}
                    </p>
                  </div>

                  {item.comment && <div className="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-lg" data-id="element-427">
                      <p className="text-xs font-semibold text-amber-800 uppercase mb-1" data-id="element-428">
                        Kommentar
                      </p>
                      <p className="text-sm text-amber-900" data-id="element-429">{item.comment}</p>
                    </div>}

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-430">
                    <div data-id="element-431">
                      <label className="text-xs font-semibold text-slate-500 uppercase block mb-2" data-id="element-432">
                        Lösungsvorschlag
                      </label>
                      <Select options={[{
                    value: '',
                    label: 'Lösung auswählen...'
                  }, ...solutions.map(s => ({
                    value: s.value,
                    label: s.value === 'filewave' ? s.label : `${s.label} ${s.cost > 0 ? `(€ ${s.cost})` : ''}`
                  }))]} value={item.selectedSolution || ''} onChange={e => handleSolutionChange(item.id, e.target.value)} data-id="element-433" />
                    </div>
                    {item.cost !== undefined && <div data-id="element-434">
                        <label className="text-xs font-semibold text-slate-500 uppercase block mb-2" data-id="element-435">
                          Kosten
                        </label>
                        {item.selectedSolution === 'pauschale' ? <Input type="number" min="0" step="0.01" placeholder="Kosten eingeben..." value={item.cost || ''} onChange={e => handleCostChange(item.id, parseFloat(e.target.value) || 0)} icon={<Euro className="h-4 w-4" data-id="element-437" />} data-id="element-436" /> : <div className="flex items-center gap-2 h-10 px-3 py-2 bg-slate-50 border border-slate-200 rounded-md" data-id="element-438">
                            <Euro className="h-4 w-4 text-slate-500" data-id="element-439" />
                            <span className="font-semibold text-slate-900" data-id="element-440">
                              {item.cost.toLocaleString('de-DE')}
                            </span>
                          </div>}
                      </div>}
                  </div>

                  {/* Filewave Configuration */}
                  {item.selectedSolution === 'filewave' && item.filewaveConfig && <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg" data-id="element-441">
                        <h4 className="text-sm font-semibold text-blue-900 mb-3" data-id="element-442">
                          Filewave MDM Lizenzierung
                        </h4>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-443">
                          <div data-id="element-444">
                            <label className="text-xs font-semibold text-slate-600 uppercase block mb-2" data-id="element-445">
                              Anzahl Mobile Clients
                            </label>
                            <div className="space-y-2" data-id="element-446">
                              <Input type="number" min="0" placeholder="0" value={item.filewaveConfig.mobileClients || ''} onChange={e => handleFilewaveConfigChange(item.id, 'mobileClients', parseInt(e.target.value) || 0)} data-id="element-447" />
                              <p className="text-xs text-slate-600" data-id="element-448">
                                € 69 pro Mobile Client
                              </p>
                            </div>
                          </div>
                          <div data-id="element-449">
                            <label className="text-xs font-semibold text-slate-600 uppercase block mb-2" data-id="element-450">
                              Anzahl Desktop Clients
                            </label>
                            <div className="space-y-2" data-id="element-451">
                              <Input type="number" min="0" placeholder="0" value={item.filewaveConfig.desktopClients || ''} onChange={e => handleFilewaveConfigChange(item.id, 'desktopClients', parseInt(e.target.value) || 0)} data-id="element-452" />
                              <p className="text-xs text-slate-600" data-id="element-453">
                                € 135 pro Desktop Client
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="mt-4 p-3 bg-white border border-blue-200 rounded-lg" data-id="element-454">
                          <div className="flex items-center justify-between" data-id="element-455">
                            <span className="text-sm font-medium text-slate-700" data-id="element-456">
                              Berechnete Lizenzkosten:
                            </span>
                            <span className="text-lg font-bold text-blue-900" data-id="element-457">
                              €{' '}
                              {(item.filewaveConfig.mobileClients * 69 + item.filewaveConfig.desktopClients * 135).toLocaleString('de-DE')}
                            </span>
                          </div>
                          <div className="mt-2 text-xs text-slate-600" data-id="element-458">
                            {item.filewaveConfig.mobileClients} Mobile (€{' '}
                            {(item.filewaveConfig.mobileClients * 69).toLocaleString('de-DE')}
                            ) + {item.filewaveConfig.desktopClients} Desktop (€{' '}
                            {(item.filewaveConfig.desktopClients * 135).toLocaleString('de-DE')}
                            )
                          </div>
                        </div>
                      </div>}
                </div>
              </div>
            </Card>)}
        </div>
      </MainLayout>;
  }
  return <MainLayout title="§390 SGB V Auditing" onLogout={onLogout} data-id="element-459">
      <div className="flex justify-between items-center mb-6" data-id="element-460">
        <div data-id="element-461">
          <h1 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-462">
            Sicherheitsaudits nach §390 SGB V
          </h1>
          <p className="text-slate-600" data-id="element-463">
            Verwaltung und Durchführung von IT-Sicherheitsaudits für
            Zahnarztpraxen
          </p>
        </div>
        <Button leftIcon={<Plus className="h-4 w-4" data-id="element-465" />} onClick={() => setShowNewAuditModal(true)} data-id="element-464">
          Neues Audit anlegen
        </Button>
      </div>

      {/* Info Card */}
      <Card className="mb-6 bg-blue-50 border-blue-200" data-id="element-466">
        <div className="flex items-start gap-3" data-id="element-467">
          <ClipboardCheck className="h-6 w-6 text-blue-600 mt-1" data-id="element-468" />
          <div data-id="element-469">
            <h3 className="font-semibold text-blue-900 mb-1" data-id="element-470">
              §390 SGB V Sicherheitsaudit
            </h3>
            <p className="text-sm text-blue-800 mb-2" data-id="element-471">
              Zahnarztpraxen werden nach Mitarbeiteranzahl in drei
              Größenkategorien eingeteilt. Je nach Kategorie müssen
              unterschiedliche Sicherheitsanforderungen erfüllt werden.
            </p>
            <p className="text-sm text-blue-700 font-medium" data-id="element-472">
              💡 Klicken Sie auf eine Audit-Karte unten, um die Detailansicht zu
              öffnen
            </p>
          </div>
        </div>
      </Card>

      {/* Audits List */}
      <div className="grid grid-cols-1 gap-4" data-id="element-473">
        {audits.map(audit => <div key={audit.id} onClick={() => setSelectedAudit(audit)} className="bg-white rounded-xl border border-slate-200 shadow-sm hover:shadow-lg hover:border-teal-300 transition-all cursor-pointer group p-6" data-id="element-474">
            <div className="flex items-center justify-between" data-id="element-475">
              <div className="flex items-center gap-4" data-id="element-476">
                <div className="p-3 bg-teal-100 rounded-lg group-hover:bg-teal-200 transition-colors" data-id="element-477">
                  <ClipboardCheck className="h-6 w-6 text-teal-600" data-id="element-478" />
                </div>
                <div data-id="element-479">
                  <h3 className="font-semibold text-slate-900 mb-1 group-hover:text-teal-600 transition-colors" data-id="element-480">
                    {audit.client}
                  </h3>
                  <div className="flex items-center gap-3 text-sm text-slate-600" data-id="element-481">
                    <span className="flex items-center gap-1" data-id="element-482">
                      <Users className="h-4 w-4" data-id="element-483" />
                      {audit.employeeCount} Mitarbeiter
                    </span>
                    <span data-id="element-484">•</span>
                    <span data-id="element-485">{getCategoryLabel(audit.category)}</span>
                    <span data-id="element-486">•</span>
                    <span data-id="element-487">{audit.items.length} Prüfpunkte</span>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-488">
                <div className="text-right" data-id="element-489">
                  <p className="text-sm text-slate-600" data-id="element-490">Erstellt</p>
                  <p className="text-sm font-medium text-slate-900" data-id="element-491">
                    {new Date(audit.createdAt).toLocaleDateString('de-DE')}
                  </p>
                </div>
                {getStatusBadge(audit.status)}
                <ChevronRight className="h-5 w-5 text-slate-400 group-hover:text-teal-600 transition-colors" data-id="element-492" />
              </div>
            </div>
          </div>)}
      </div>

      {/* New Audit Modal */}
      {showNewAuditModal && <Modal isOpen={showNewAuditModal} onClose={() => setShowNewAuditModal(false)} title="Neues Audit anlegen" data-id="element-493">
          <div className="space-y-4" data-id="element-494">
            <div data-id="element-495">
              <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-496">
                Praxisname
              </label>
              <Input placeholder="z.B. Zahnarztpraxis Dr. Müller" value={newAuditData.client} onChange={e => setNewAuditData({
            ...newAuditData,
            client: e.target.value
          })} data-id="element-497" />
            </div>

            <div data-id="element-498">
              <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-499">
                Anzahl Mitarbeiter
              </label>
              <Input type="number" placeholder="z.B. 8" value={newAuditData.employeeCount} onChange={e => setNewAuditData({
            ...newAuditData,
            employeeCount: e.target.value
          })} data-id="element-500" />
            </div>

            <div data-id="element-501">
              <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-502">
                Größenkategorie
              </label>
              <Select options={[{
            value: 'small',
            label: 'Klein (1-5 Mitarbeiter)'
          }, {
            value: 'medium',
            label: 'Mittel (6-20 Mitarbeiter)'
          }, {
            value: 'large',
            label: 'Groß (>20 Mitarbeiter)'
          }]} value={newAuditData.category} onChange={e => setNewAuditData({
            ...newAuditData,
            category: e.target.value as 'small' | 'medium' | 'large'
          })} data-id="element-503" />
            </div>

            <div className="flex justify-end gap-3 pt-4" data-id="element-504">
              <Button variant="outline" onClick={() => setShowNewAuditModal(false)} data-id="element-505">
                Abbrechen
              </Button>
              <Button onClick={handleCreateAudit} disabled={!newAuditData.client || !newAuditData.employeeCount} data-id="element-506">
                Audit erstellen
              </Button>
            </div>
          </div>
        </Modal>}
    </MainLayout>;
}